import {noop} from '@github-ui/noop'
import {createContext} from 'react'

export const ViewMode = {
  ReviewComments: 'review-comments',
  ThreadPreviews: 'thread-previews',
  IssueComments: 'issue-comments',
} as const

export type ViewMode = (typeof ViewMode)[keyof typeof ViewMode]

export interface CommentsContext {
  viewMode: ViewMode
  setViewMode: (viewMode: ViewMode) => void
  detailThreadId: string | undefined
  setDetailThreadId: (threadId: string | undefined) => void
}

export const CommentsContext = createContext<CommentsContext>({
  viewMode: ViewMode.ThreadPreviews,
  setViewMode: noop,
  detailThreadId: undefined,
  setDetailThreadId: noop,
})
